import { defineMessages } from 'react-intl';

export default defineMessages({
    hidePackageCoverages: {
        id: 'policy.common.component.cp-coverages-component.hide vehicle coverages',
        defaultMessage: 'Hide Package Coverages'
    },
    showPackageCoverages: {
        id: 'policy.common.component.cp-coverages-component.show vehicle coverages',
        defaultMessage: 'Show Package Coverages'
    },
    limit: {
        id: 'policy.common.component.cp-coverages-component.Limit',
        defaultMessage: 'Limit'
    },
    deductible: {
        id: 'policy.common.component.cp-coverages-component.Deductible',
        defaultMessage: 'Deductible'
    },
    coverage: {
        id: 'policy.common.component.cp-coverages-component.Coverage',
        defaultMessage: 'Coverage',
    },
    buildings: {
        id: 'policy.common.component.cp-coverages-component.Buildings',
        defaultMessage: 'Buildings',
    },
    Coverage: {
        id: 'policy.common.component.cp-coverages-component.Coverage',
        defaultMessage: 'Coverage',
    },
    NoBuilding: {
        id: 'policy.common.component.cp-coverages-component.NoBuilding',
        defaultMessage: 'NoBuilding',
    },
    CoveragesEmpty: {
        id: 'policy.common.component.cp-coverages-component.CoveragesEmpty',
        defaultMessage: 'CoveragesEmpty',
    },
    CPLocation: {
        id: 'policy.common.component.cp-coverages-component.Location',
        defaultMessage: 'Location',
    }

});
